export const DEFAULT_BRANCH_NAME = 'master';
